import { Injectable } from '@angular/core';
import { HotToastService } from '@ngxpert/hot-toast';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(private readonly _toast: HotToastService) { }

    notify(message: string): void {
        this._toast.success(message, {
            duration: 5000,
            style: {
                border: '1px solid #04b746',
                padding: '16px',
                background: '#04b746',
                color:"#fff"
            },
            iconTheme: {
                primary: '#fff',
                secondary: '#04b746',
            },
        });
    }
}
